module.exports = __webpack_public_path__ + "static/media/logo.5b36c18b.svg";